<template>
    <div>
      <!-- v-if="store.state.user != '' && !logoutUser" -->
        Your account has been succesfully log out
    </div>
</template>

<script>
import store from './../../store/index.js'
export default {
  name: 'Logout',
  data: function () {
    return {
      // config: Config,
      store: store,
      logoutUser: false
    }
  },
  methods: {
    logoutAccount () {
      this.request('/logout', 'POST', {}).then((response) => {
        if (response.code === 0) {
          this.logoutUser = true
          // localStorage.clear()
          setTimeout(() => {
            this.store.commit('setToken', {})
            this.$auth.logout({
              logoutParams: {
                returnTo: window.location.origin
              }
            });
          }, 3000)
        }
      }).catch((error) => {
      })
    },
    clearData () {
      this.store.commit('setDriver', {})
      this.store.commit('setUser', {})
    }
  },
  created: function () {
    this.logoutAccount()
    this.clearData()
  }
}
</script>
